import React from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {isEmpty, map} from 'lodash';

import './index.css';

const AdminStatisticsScreen = ({
 showStats,
 showStatsWithTimePeriod,
 statistics,
 statsWithTimePeriod,
}) => {
  const [ t ] = useTranslation();

  const headers = [
    t('adminStatisticsTable.headers.name'),
    t('adminStatisticsTable.headers.allUsers'),
    t('adminStatisticsTable.headers.activeUsers'),
    t('adminStatisticsTable.headers.usersWithAtLeastOneCommit'),
    t('adminStatisticsTable.headers.datetimeOfFirstCommit'),
    t('adminStatisticsTable.headers.datetimeOfSecondCommit'),
    t('adminStatisticsTable.headers.datetimeOfLastCommit'),
    t('adminStatisticsTable.headers.averageCommitsPerUser'),
    t('adminStatisticsTable.headers.averageCommitsPerMonth'),
    t('adminStatisticsTable.headers.numberOfCommits'),
  ];

  const timePeriodTableHeaders = [
    t('adminStatisticsTable.headers.name'),
    t('adminStatisticsTable.timePeriodTableHeaders.numberOfCommits'),
  ];

  const formatters = (key, value) => {
    switch (key) {
      case 'datetimeOfFirstCommit':
      case 'datetimeOfSecondCommit':
      case 'datetimeOfLastCommit':
        if (moment(value).isValid()) {
          return moment(value).format('DD.MM.YYYY. HH:mm:ss');
        }
        return 'None';
      default:
        return value;
    }
  };

  if ((isEmpty(statistics) && showStats) || (isEmpty(statsWithTimePeriod) && showStatsWithTimePeriod)) {
    return (
        <>{t('adminStatisticsTable.noClientsSelected')}</>
    )
  }

  const renderMainTable = () => (
      <Table striped bordered hover>
        <thead>
        <tr>
          {/* eslint-disable-next-line no-unused-vars */}
          {headers.map((header, i) => {
            return <th key={header}>{header}</th>
          })}
        </tr>
        </thead>
        <tbody>
        {
          map(statistics, (row, clientName) => (
            <tr key={clientName}>
              <td>
                {clientName}
              </td>
              {
                map(row, (value, key) => (
                    <td>
                      {formatters(key, value)}
                    </td>
                ))
              }
            </tr>
          ))
        }
        </tbody>
      </Table>
  );

  let idx = 0;
  const renderTimePeriodTable = () => (
      <Table striped bordered hover>
        <thead>
        <tr>
          {/* eslint-disable-next-line no-unused-vars */}
          <th>#</th>
          {timePeriodTableHeaders.map((header, i) => {
            return <th key={header}>{header}</th>
          })}
        </tr>
        </thead>
        <tbody>
        {
          map(statsWithTimePeriod, (row, clientName) => (
            <tr key={clientName}>
              <td>{++idx}</td>
              <td>
                {clientName}
              </td>
              {
                map(row, (value, key) => (
                    <td>
                      {formatters(key, value)}
                    </td>
                ))
              }
            </tr>
          ))
        }
        </tbody>
      </Table>
  );

  return (
      <>
        {showStats && renderMainTable()}
        {showStatsWithTimePeriod && renderTimePeriodTable()}
      </>
  );
};

AdminStatisticsScreen.propTypes = {
  showStats: PropTypes.bool,
  showStatsWithTimePeriod: PropTypes.bool,
  statistics: PropTypes.object,
  statsWithTimePeriod: PropTypes.object,
};

export default AdminStatisticsScreen;